import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const mode = "hash";
const routes = [
  {
    path: "/",
    name: "Home",
    component: () =>
      import( "@v/TheHome.vue")
  },
  {
    path:'*',
    redirect:'/'
  },
  {
    path: "/AboutMe",
    name: "AboutMe",
    component: () =>
      import( "@v//TheAboutMe.vue")
  },
  {
    path: "/Portfolio",
    name: "Portfolio",
    component: () =>
      import( "@v/ThePortfolio.vue")
  },
  {
    path: "/ContactMe",
    name: "ContactMe",
    component: () =>
      import( "@v/TheContactMe.vue")
  },
  {
    path: "/PersonalTools",
    name: "PersonalTools",
    component: () =>
      import( "@v/ThePersonalTools.vue")
  },
  {
    path: "/AboutWebsite",
    name: "AboutWebsite",
    component: () =>
      import( "@v/TheAboutWebsite.vue")
  }
];

const router = new VueRouter({
  mode,
  routes
});

export default router;
